import { render, staticRenderFns } from "./WrapperProfile.vue?vue&type=template&id=7df72f7e&"
import script from "./WrapperProfile.vue?vue&type=script&lang=js&"
export * from "./WrapperProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports